module.exports = __webpack_public_path__ + "static/media/排行榜_2.999d0127.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/Home/components/TriennialsSpecial/HomeRankingModule/assets/images/排行榜_2.png
// module id = 429
// module chunks = 0